import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import { HeaderCtAsNodeFragment } from "../../types/graphql";
import { PureHeaderCTAs } from "./pure-header-ctas";
import { useMergePrismicPreviewData } from "gatsby-plugin-prismic-previews";

interface IHeaderCTAsProps {
  headerCTAsUID: string;
  setHeaderCTAsData: (data: HeaderCtAsNodeFragment) => void;
}

const query = graphql`
  query HeaderCTAs {
    allPrismicHeaderCtas {
      edges {
        node {
          ...HeaderCTAsNode
        }
      }
    }
  }
`;

export default function RenderHeaderCTAs(props: IHeaderCTAsProps) {
  const staticData = useStaticQuery(query);
  return (
    <PureHeaderCTAs
      headerCTAs={useMergePrismicPreviewData(staticData)}
      headerCTAsUID={props.headerCTAsUID}
      setHeaderCTAsData={props.setHeaderCTAsData}
    />
  );
}
